import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconUser = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 15 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7.5 7.5c.781 0 1.53-.321 2.083-.892a3.1 3.1 0 0 0 .863-2.155A3.1 3.1 0 0 0 9.583 2.3 2.898 2.898 0 0 0 7.5 1.406c-.781 0-1.53.321-2.083.893a3.1 3.1 0 0 0-.863 2.154 3.1 3.1 0 0 0 .863 2.155A2.898 2.898 0 0 0 7.5 7.5ZM6.448 8.643c-2.267 0-4.104 1.9-4.104 4.244 0 .39.306.707.683.707h8.946a.696.696 0 0 0 .683-.707c0-2.345-1.837-4.244-4.104-4.244H6.448Z"
	})
});
export default SvgIconUser;
